

import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Pagination,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ExportDropdown from "../../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../../components/CustomText";
import StatusDropdown from "../../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import DetailsDrawer from "./DetailsDrawer";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import FilterDrawer from "./filterDrawer.js";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import emptypayment from "../../../../assets/emptypayment.png";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExportRemunerationExcel from "./ExportExcel.js";
import ExportRemunerationPDF from "./ExportPdf.js";
import { pdf } from "@react-pdf/renderer";
import {useCompanyLogo} from "../../../../components/FetchLogoPdf";
import {useLocation,useNavigate} from "react-router-dom";
import back from "../../../../assets/back.svg";
import {toast} from "react-hot-toast"
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
const headerStyle = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const dataStyle = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const Remuneration = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
  const [expenses, setExpenses] = useState([]);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    startDate: "",
    endDate: "",
  });

  // 🔹 backend pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 5;

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const fetchExpenses = async (
    page = 1,
  
    isInitial = false,
    appliedFilters = filters
  ) => {
    try {
      if (isInitial) {
        setInitialLoading(true);
      } else {
        setLoading(true);
      }

      let filterQuery = "";
      if (appliedFilters.status)
        filterQuery += `&status=${appliedFilters.status}`;
      if (appliedFilters.startDate)
        filterQuery += `&from=${appliedFilters.startDate}`;
      if (appliedFilters.endDate)
        filterQuery += `&to=${appliedFilters.endDate}`;

      const res = await fetch(
        `${BASE_URL}/worker/remuneration?page=${page}&page_size=${pageSize}${filterQuery}`,

        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await res.json();
      if (!result.error) {
        setExpenses(result.data || []);

        // map pagination from backend
        if (result.meta) {
          setCurrentPage(result.meta.page || 1);
          setTotalPages(Math.ceil(result.meta.total / result.meta.page_size));
        }
      }
    } catch (err) {
      console.error("Error fetching expenses:", err);
    } finally {
      if (isInitial) setInitialLoading(false);
      else setLoading(false);
    }
  };

useEffect(() => {
  fetchExpenses(1, true, filters);
}, []);


  // const firstLoad = useRef(true);

  // useEffect(() => {
  //   if (firstLoad.current) {
  //     firstLoad.current = false;
  //     return;
  //   }
  //   const delayDebounce = setTimeout(() => {
  //     fetchExpenses(1, searchTerm, false, filters); // reset to page 1 for new search
  //   }, 500);
  //   return () => clearTimeout(delayDebounce);
  // }, [searchTerm]);

  const handleMenuOpen = (e, row) => {
    setAnchorEl(e.currentTarget);
    setSelectedRow(row);
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setDrawerOpen(true);
    setAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
const getPaymentMonth = (dateString) => {
  if (!dateString) return "-";
  const localMonth = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      month: "long",
      year: "numeric",
    },
  });
  return localMonth === "—" ? "-" : localMonth;
};
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const localDate = convertUTCToLocalDateTime(dateString, {
      locale: "en-GB",
      formatOptions: {
        day: "2-digit",
        month: "short",
        year: "numeric",
      },
    });
    return localDate === "—" ? "-" : localDate;
  };

  const typeLabels = {
    expense_reimbursement: "Expense Reimbursement",
    salary: "Salary",
  };


const { logo } = useCompanyLogo(token);
  const fetchAllRemuneration = async (token, filters = {}) => {
  try {
  let url = `${BASE_URL}/worker/remuneration?no_pagination=true`;


    if (filters.status) url += `&status=${filters.status}`;
    if (filters.startDate) url += `&from=${filters.startDate}`;
    if (filters.endDate) url += `&to=${filters.endDate}`;

    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const json = await res.json();

    if (json.error) {
      console.error("❌ Failed to fetch remuneration:", json.message);
      return [];
    }

    return (json.data || []).map((item) => ({
      id: item.id,
      type: item.type,
      amount: `${item.amount} ${item.currency || ""}`,
      date: formatDateTime(item.paid_at),
      proof: item.attachment_url ? "Available" : "-",
      status: item.status || "-",
      comments: item.note || "-",
    }));
  } catch (err) {
    console.error("❌ Error fetching all remuneration:", err);
    return [];
  }
};
const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "USD":
      return "$";
    case "EUR":
    case "EURO":
      return "€";
   
    default:
      return currency || ""; // fallback: show the text if no match
  }
};
const [filteredExpenses, setFilteredExpenses] = useState([]);
useEffect(() => {
  if (!searchTerm.trim()) {
    setFilteredExpenses(expenses);
  } else {
    const lower = searchTerm.toLowerCase();
    const filtered = expenses.filter(
      (item) =>
        item.type?.toLowerCase().includes(lower) ||
        item.status?.toLowerCase().includes(lower) ||
        item.note?.toLowerCase().includes(lower) ||
        item.currency?.toLowerCase().includes(lower)
    );
    setFilteredExpenses(filtered);
  }
}, [searchTerm, expenses]);

  return (
    <>
                     {fromDashboard && (
      <Box
        sx={{
          border: '1px solid #E4E6EF',
          borderRadius: 2,
          px: 2,
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: 55,
          mb: 2,
          ml:1, mr:1
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
          onClick={() => navigate(-1)}
        >
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: '14px',
              color: '#626F86',
              textAlign: 'center'
            }}
          >
            {t('worker')} 
          </CustomText>
        </Box>
      </Box>
    )}
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        border: "2px solid #091E4224",
        py: 2,
        px: 0,
        ml: 1,
        mr: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ flex: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
              textAlign: "left",
            }}
          >
{t("remunerationRecords")}
        </CustomText>
          {!initialLoading && loading && (
            <CircularProgress size={18} sx={{ ml: 1 }} />
          )}
        </Box>

        {/* Search */}
        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            placeholder={t("reimbursementRequest.placeholder")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              color: "#939393",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
        </Box>

   <ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllRemuneration(token, filters);
    const blobStream = pdf(<ExportRemunerationPDF data={allData}  logo={logo}/>).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Remuneration_Report_${new Date().toISOString().slice(0, 10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllRemuneration(token, filters);
    ExportRemunerationExcel(allData);
  }}
/>

               {filters.status || filters.startDate || filters.endDate ? (
          <Box
            sx={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 34,
              height: 34,
              borderRadius: 1,
              bgcolor: "#1976d2",
            }}
          >
            <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />
            <IconButton
              size="small"
              onClick={() => {
    const cleared = { status: "", startDate: "", endDate: "" };
    setFilters(cleared);
    setCurrentPage(1);
    fetchExpenses(1, searchTerm, false, cleared); // 👈 pass 1 as first arg
  }}
              sx={{
                position: "absolute",
                top: -6,
                right: -6,
                bgcolor: "white",
                width: 18,
                height: 18,
                border: "1px solid #C4C4C4",
                "&:hover": { bgcolor: "#f5f5f5" },
              }}
            >
              <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
            </IconButton>
          </Box>
        ) : (
          <IconButton
            onClick={() => setFilterDrawerOpen(true)}
            sx={{
              border: "1px solid #C4C4C4",
              borderRadius: 1,
              width: 34,
              height: 34,
            }}
          >
            <FilterAltIcon />
          </IconButton>
        )}
      </Box>

      {/* Table */}
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headerStyle}>{t("remuneration.tableHeaders.id")}</TableCell>
                   <TableCell sx={headerStyle}>{t("salary")}</TableCell>
                  <TableCell sx={headerStyle}>
      {t("remuneration.tableHeaders.paymentMonth")}
    </TableCell>
         


<TableCell sx={headerStyle}>{t("remuneration.tableHeaders.date")}</TableCell>
<TableCell sx={headerStyle}>{t("remuneration.tableHeaders.type")}</TableCell>
    <TableCell sx={headerStyle}>
      {t("remuneration.tableHeaders.proof")}
    </TableCell>
<TableCell sx={headerStyle}>{t("remuneration.tableHeaders.status")}</TableCell>
<TableCell sx={headerStyle}>{t("remuneration.tableHeaders.comments")}</TableCell>
<TableCell sx={headerStyle}>{t("remuneration.tableHeaders.action")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {initialLoading ? (
              <TableRow>
                <TableCell colSpan={10} sx={{ textAlign: "center" }}>
                  <CircularProgress size={40} />
                </TableCell>
              </TableRow>
            ) :
          filteredExpenses.length === 0 ? (
              <TableRow>
                <TableCell colSpan={10}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: 5,
                    }}
                  >
                    <img
                      src={emptypayment}
                      alt="No Data"
                      style={{ width: 200, marginBottom: 16 }}
                    />
                    <CustomText
                      sx={{
                        ...textStyles.h1,
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#003149",
                      }}
                    >
                      {t("empty.no_user")}
                    </CustomText>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
        filteredExpenses.map((item) => (
                <TableRow key={item.id}>
                  <TableCell sx={dataStyle}>{item.id}</TableCell>
                   <TableCell sx={dataStyle}>
  {getCurrencySymbol(item.currency)} {item.amount}
                  </TableCell>
                     <TableCell sx={dataStyle}>
      {getPaymentMonth(item.paid_at)}
    </TableCell>
                  
                       <TableCell sx={dataStyle}>
                    {formatDateTime(item.paid_at)}
                  </TableCell>

                  <TableCell sx={dataStyle}>
                    {typeLabels[item.type] || item.type}
                  </TableCell>
                 
{/*              
                  <TableCell sx={dataStyle}>
      {item.attachment_url ? (
        <IconButton
          size="small"
          onClick={() => window.open(item.attachment_url, "_blank")}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      ) : (
        "-"
      )}
    </TableCell> */}
<TableCell sx={dataStyle}>
  {item.attachment_url ? (
    <IconButton
      size="small"
      onClick={async () => {
        try {
          const res = await fetch(item.attachment_url, { method: "HEAD" });

          if (!res.ok) {
            throw new Error("File not found");
          }

          window.open(item.attachment_url, "_blank");
        } catch (error) {
          toast.error(t("files.brokenLink"));
        }
      }}
    >
      <VisibilityIcon fontSize="small" />
    </IconButton>
  ) : (
    "-"
  )}
</TableCell>
                  <TableCell sx={dataStyle}>
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown currentStatus={item.status} />
                    </Box>
                  </TableCell>
                  <TableCell sx={dataStyle}>
                    <TruncatedCell text={item.note || "-"} />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={(e) => handleMenuOpen(e, item)}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {/* Backend Pagination */}
        {expenses.length > 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, value) =>
                fetchExpenses(value, searchTerm, false, filters)
              }
              shape="rounded"
              color="primary"
              size="small"
              sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: 13,
                  fontWeight: 500,
                },
                "& .Mui-selected": {
                  backgroundColor: "#E9F3FF",
                  color: "#006EC2",
                },
              }}
            />
          </Box>
        )}
      </Box>
       <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MenuItem
            onClick={() => handleView(selectedRow)}
            sx={{ fontSize: 14, fontFamily: "Poppins, sans-serif" }}
          >
            {t("unvalidatedPunches.tableActions.view")}
          </MenuItem>
        </Menu>
      {/* Filter Drawer */}
      <FilterDrawer
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        filters={filters}
        setFilters={setFilters}
        onApplyFilters={(newFilters) => {
          setFilters(newFilters);
          fetchExpenses(1, searchTerm, false, newFilters);
        }}
      />

      {/* Details Drawer */}
      <DetailsDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        data={selectedRow}
      />
    </Box>
    </>
  );
};

export default Remuneration;




